export default "__VITE_ASSET__CYyNqsgi__"